import React, { useEffect, useState } from 'react';
import { Card } from 'reactstrap';
import classNames from 'classnames';
import ToggleButton from "../ToggleButton/ToggleButton";
export default function CollapsableCard(props) {
    var _a = useState(props.collapsed ? props.collapsed : false), collapsed = _a[0], setCollapsed = _a[1];
    useEffect(function () {
        setCollapsed(props.collapsed);
    }, [props.collapsed]);
    var classes = classNames({ 'collapsable-card': true, 'collapsable-card--collapsed': collapsed });
    return React.createElement(Card, { className: classes + " " + props.className },
        React.createElement("div", { className: 'collapsable-card__wrapper' }, props.children),
        React.createElement(ToggleButton, { onClick: function () { return setCollapsed(!collapsed); }, open: collapsed }));
}
